import { render, staticRenderFns } from "./ViewSkillPage.vue?vue&type=template&id=1087732a&"
import script from "./ViewSkillPage.vue?vue&type=script&lang=js&"
export * from "./ViewSkillPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports